<template>
  <div class="app">
    <nav class="menu">
      <div class="content">
        <img src="../assets/logo.png"/>
        <span class="name">消考实操模拟平台</span>
        <div class="right-menu">
          <span class="free" @click="downloadPdf">下载考试大纲</span>
          <span @click="visible=true">常见问题</span>
        </div>
      </div>
    </nav>
    <div class="container">
      <div class="main-wrapper index">
        <div class="main index">
          <div class="index-content">
            <div class="title"><div><span>消考实操</span>模拟平台</div><span class="subfix">国考仿真版</span></div>
            <div class="sub-title">
              <span class="pc">电脑版用户可点击下方链接免费下载Windows/Mac客户端进行实操模拟</span>
              <span class="phone">手机版用户可以扫描下方二维码便捷进入或下载消考实操模拟实平台APP</span>
              <span class="h5">电脑端下载请用电脑访问官网即可下载，手机端可以登录App Store、应用宝、小米商店、华为商店和Vivo商店下载</span>
              <span><i>机构用户</i>可以联系微信：xiaokaoshicao10，开通机构版使用权限</span>
            </div>
            <div class="buttons">
              <div class="pc" @click="downloadClient"><img src="../assets/pc.png" /><span>{{ text }}</span></div>
              <div class="toggle" @click="toggleClient"><span></span></div>
              <div class="version-list" v-show="versionVis">
                <div v-for="item in list" class="version" @click="toggleVersion(item)"><img /><span>{{ item.text }}</span></div>
              </div>
            </div>
          </div>
          <div class="video"><img src="../assets/video.jpg"/></div>
        </div>
        <div class="app">
          <div class="ddd">
            <img src="../assets/mini.png" class="icon"/><span>微信小程序版本</span>
            <div class="qrcode">
              <img src="../assets/wechat-mini.png"/>
            </div>
          </div>
          <div class="ddd">
            <img src="../assets/pingguo.png" class="icon"/><span>苹果手机扫码下载</span>
            <div class="qrcode">
              <img src="../assets/ios-download.png"/>
            </div>
          </div>
          <div class="ddd">
            <img src="../assets/android.png" class="icon"/><span>安卓手机扫码下载</span>
            <div class="qrcode">
              <img :src="qrcode"/>
            </div>
        </div>
       
      </div>
      <div class="m-app">
          <div class="ddd">
            <span>手机扫码下载</span>
            <div class="qrcode">
              <img src="../assets/ios-download.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="main-wrapper jobs">
        <div class="main">
          <h3><span class="color">“零”基础</span><span> 轻松过关</span></h3>
          <div class="items">
            <div class="item">
              <img src="../assets/function.png"/>
            </div>
            <!-- <div class="item">
              <img src="../assets/func2.png"/>
            </div>
            <div class="item">
              <img src="../assets/func3.png"/>
            </div>
            <div class="item">
              <img src="../assets/func4.png"/>
            </div>
            <div class="item">
              <img src="../assets/func5.png"/>
            </div>
            <div class="item">
              <img src="../assets/func6.png"/>
            </div>
            <div class="item">
              <img src="../assets/func7.png"/>
            </div> -->
          </div>
        </div>
      </div>
      <div class="main-wrapper mutil">
        <div class="main">
          <h3><span class="color">“多”终端兼容</span> 到哪都能学</h3>
          <p>消考实操模拟平台目前已支持Windows系统（32位/64位）、MacOS系统、苹果手机、安卓手机、微信小程序</p> 
          <img src="../assets/mutil.png" style="width:80%;margin-top:40px ;"/>
        </div>
      </div>
      <div class="main-wrapper hezuo">
        <div class="main">
          <h3>合作机构</h3>
          <p>机构用户可以咨询微信：xiaokaoshicao10，<span>开通机构专版</span></p>
          <div class="lists">
            <div><img src="../assets/kejie.png"/></div>
            <div><img src="../assets/hengxun.png"/></div>
            <div><img src="../assets/lanhe.jpeg"/></div>
            <div><img src="../assets/shunrui.jpeg"/></div>
            <div><img src="../assets/youzan.jpeg"/></div>
            <div><img src="../assets/shiernian.jpeg"/></div>
            <div><img src="../assets/tianlan.jpeg"/></div>
            <div><img src="../assets/hengyuan.jpeg"/></div>
            <div><img src="../assets/huide.jpeg"/></div>
            <div><img src="../assets/tean.png"/></div>
            
          </div>
        </div>
      </div>
      <div class="main-wrapper demo">
        <div class="main">
          <h3>界面演示</h3>
          <div class="lists">
            <div class="item">
              <img src="../assets/demo1.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo2.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo3.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo4.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo5.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo6.png"/>
            </div>
            <div class="item" >
              <img src="../assets/demo99.png" style="width: 1000px;height: auto;"/>
            </div>
          </div>
        </div>
      </div>
      <div class="main-wrapper footer">
        <div class="main" style="font-weight:normal">
          Copyright &COPY; 2023 www.superbtrip.cn  <a href="https://beian.miit.gov.cn" style="color:#fff;text-decoration: none;">沪ICP备19026759号-7</a>
        </div>
      </div>
    </div>
    <div class="popup" v-show="visible">
      <div class="p-body">
        <div class="p-title">常见问题<span @click="visible=false">x</span></div>
        <div class="p-content">
          <p class="q">问：32位系统安装包怎么下载？</p>
          <p class="a">答：32位系统已经在官网首页适配展示为“点击下载windows客户端（32位）”，点击按钮即可以下载32位安装包</p>
          </div>
          <div class="line"></div>
        <div class="p-content">
          <p class="q">问:  仿真功能白屏怎么办?</p>
          <p class="a">答:  消考实操在window 7 sp1版本的操作系统下会出现白屏现象，解决方案如下：1、关闭360、腾讯管家和消考实操；2、打开链接<a href="https://www.wosign.com/download/winroot.htm" target="_blank">证书下载</a>，点击页面中“下载”，下载完成后，双击安装证书；3、安装证书完成后，重新启动消考实操，即可解决白屏问题。</p>
        </div>
      </div>
    </div>
    <div class="popup" v-show="cvisible">
      <div class="p-body">
        <div class="p-title">免费领取账号<span @click="cvisible=false">x</span></div>
        <div class="p-content">
          <p>联系电话：13899999999（微信同号）</p>
          <p><span>公司名称：</span><div><input type="text"/></div></p>
          <p><span>联系人：</span><div><input type="text"/></div></p>
          <p><span>联系电话：</span><div><input type="text"/></div></p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yaml from 'js-yaml'
import axios from 'axios'
import QRCode from 'qrcode'
export default {
  name: 'app',
  data() {
    return {
      showios: false,
      showand: false,
      download: '',
      config: '',
      text: '点击下载Windows客户端 (64位)',
      visible: false,
      cvisible: false,
      qrcode: '',
      list: [{
        type: 'win64',
        text: '点击下载Windows客户端 (64位)'
      },{
        type: 'win32',
        text: '点击下载Windows客户端 (32位)'
      },{
        type: 'mac',
        text: '点击下载Mac客户端'
      }],
      currType: '',
      versionVis: false
    };
  },
  created() {
    console.log('=====')
    this.genAndroidCode()
  },
  methods: {
    showcode(key) {
      if (key === 'ios') {
        this.showios = true
      } else {
        this.showand = true
      }
    },
    hidecode(key) {
      if (key === 'ios') {
        this.showios = false
      }else{
        this.showand = false
      }
    },
    async getPosType() {
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
          this.currType = 'win32'
          this.list = []
          this.getWin32()
          
      }
      if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
          this.currType = 'win64'
          
          this.getWin64()
      }
      if (isMac) {
          this.currType = 'mac'
          this.getMac()
      }
    },
    async loadFile(url) {
      return await axios.get(url, {
        withCredentials: false,
      }).then(res => res.data)
    },
    downloadClient(){
      location.href = this.download
    },
    async genAndroidCode() {
      const config = await this.loadFile('https://register.firepal.cn/data/config.json')
      this.qrcode = await QRCode.toDataURL(config.update.download, {margin: 2})
    },
    async getWin32() {
      const yml = await this.loadFile('https://xfsc.firepal.cn/update/win32/ia32/latest.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update/win32/ia32/' + config.files[0].url
          this.text = '点击下载Windows客户端(v'+config.version+') (32位)'
    },
    async getWin64() {
      const yml = await this.loadFile('https://xfsc.firepal.cn/update/win32/x64/latest.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update/win32/x64/' + config.files[0].url
          this.text = '点击下载Windows客户端(v'+config.version+') (64位)'
    },
    async getMac() {
      const yml = await this.loadFile('https://xfsc.firepal.cn/update/darwin/latest-mac.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update/darwin/' + config.files[1].url
          this.text = '点击下载Mac客户端(v'+config.version+')'
    },
    toggleClient() {
      if (this.versionVis) {
        this.versionVis = false
      } else {
        this.versionVis = true
      }
    },
    toggleVersion(data) {
      this.versionVis = false
      if (data.type === 'win32') {
        this.getWin32()
      } else if (data.type === 'win64') {
        this.getWin64()
      } else {
        this.getMac()
      }
    },
    downloadPdf() {
      // 新窗口打开下载链接
      window.open('https://www.firepal.cn/dl/%E8%80%83%E7%BA%B2%E4%B8%8B%E8%BD%BD.zip', '_blank')
    }
  },
  mounted() {
    this.getPosType()
  }
};
</script>

<style lang="less">
@font-face {
	  font-family: 'Truth';
	  src: url('../assets/fonts/AlimamaShuHeiTi-Bold.woff') format('woff'), url('../assets/fonts/AlimamaShuHeiTi-Bold.otf') format('otf'), url('../assets/fonts/AlimamaShuHeiTi-Bold.ttf') format('opentype');
	  font-style: normal;
	  font-weight: normal;
	}
html,
body {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  width: 100%;
  /* overflow: hidden; */
  font-family: "microsoft yahei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.app {
  /* height: 100%; */
  width: 100%;
}
p {
  /* margin: 0; */
  /* text-align: center; */
  /* width: 800px; */
  margin: 0 auto;
}
h1,h3,h4,h2,h5{
  padding: 0;
  margin: 0;
}
h3{
  font-size: 36px;
  margin-bottom: 20px;
  font-family: 'Truth';
  font-weight: normal;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}
.container{
  width: 100%;
}
.menu{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.3);
  .content{
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 15px 0;
    font-size: 24px;
    // justify-content: space-between;
    img{
      width: 48px;
      height: 48px;
      margin-right: 20px ;
      border-radius: 10px;
    }
    .name{
      color: #376FF6;
      font-size: 20px;
      // font-weight: 800;
      font-family: 'Truth';
    }
  }
  .right-menu{
    font-size: 16px;
    color: #333;
    cursor: pointer;
    font-weight: 500;
    margin-left: auto;
  }
  .free{
    margin-right: 30px;
    color: #376FF6;
    position: relative;
    &::before{
      content: '热门';
      font-size: 10px;
      position: absolute;
      right: -20px;
      top: -15px;
      background-color: #CE5653;
      color: #fff;
      padding: 0 5px;
      border-radius: 10px;
    }
  }
}

.main{
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  /* display: inline-block; */
  &.index{
    margin-top: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: space-between;
    h1{
      font-size: 48px;
    }
    h4{
      font-size: 36px;
      font-weight: 400;
      margin-top: 20px;
      margin-bottom: 50px;
    }
    .video{
      width: 495px;
      height: 285px;
      background: #f1f1f1;
      img{
        width: 495px;
        height: 285px;
      }
    }
    
  }
  &.resume{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.button-code{
  width: 190px;
  height: 50px;
  border-radius: 50px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #333;
  cursor: pointer;
  img{
    width: 20px;
    height: 22px;
    margin-right: 20px;
  }
}
.index-phone {
  display: inline-block;
  img{
    width: 264px;
    margin-right: 150px;
  }
}
.index-content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .title{
    font-size: 54px;
    // font-weight: 800;
    font-family: 'Truth';
    color: #333;
    display: flex;
    align-items: flex-end;
    div{
      
      span:first-child{
        color: #CE5653;
        font-family: 'Truth';
        font-size: 54px;
      }
    }
    
    .subfix{
      font-family: 'Truth';
      font-size: 26px;
      margin-left: 20px;
    }
  }
  .sub-title{
    margin-top: 20px;
    font-size: 14px;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100px;
    justify-content: space-between;
    i{
      color: #CE5653;
      font-style: normal;
    }
    .h5{
      display: none;
    }
    span{
      position: relative;
      padding-left: 20px;
      &::before{
        position: absolute;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #333;
        font-size: 0;
        line-height: 0;
        transform: rotate(90deg);
        display: inline-block;
        content: "";
        left: 0;
        top: 50%;
        margin-top: -3px;
      }
    }
  }
}
.buttons{
  position: relative;
  margin-top: 50px;
  .toggle{
    position: absolute;
    height: 44px;
    width: 80px;
    border-left: 1px solid #fff;
    right: 0;
    top: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 0 50px 50px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span{
      width: 0;
      height: 0;
      border-top: 8px solid #fff;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      
    }
  }
  .version-list{
    position: absolute;
    background: #fff;
    border-radius: 10px;
    top: 55px;
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    z-index: 999999;
    .version{
      color: #333;
      margin-bottom: 30px;
      cursor: pointer;
      &:hover{
        color: #376FF6;
      }
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
  .pc{
    display: flex;
    align-items: center;
    width: 500px;
    background: #376FF6;
    border-radius: 50px;
    justify-content: center;
    height: 44px;
    cursor: pointer;
    
    img{
      height: 20px;
      margin-right: 10px;
    }
  }
  
}
.main-wrapper{
  width: 100%;
  display: inline-block;
  &.index{
    height: 750px;
    background: url('../assets/bgggg.png');
    background-size: 100% auto;
    .m-app{
      display: none;
    }
    .app{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 1200px;
      margin: 60px auto 50px auto;
      .ddd{
        display: flex;
        align-items: center;
        
        width: 240px;
        background: #376FF6;
        border-radius: 50px;
        justify-content: center;
        height: 44px;
        cursor: pointer;
        position: relative;
        .icon{
          height: 20px;
          margin-right: 10px;
        }
        .qrcode{
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 70px;
          box-sizing: border-box;
          border: 5px solid #fff;
          background-color: #fff;
          border-radius: 5px;
          &::before{
            width: 0;
            height: 0;
            border-bottom: 10px solid #fff;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            font-size: 0;
            line-height: 0;
            top: -14px;
            left: 50%;
            transform: translateX(-50%);
            display: inline-block;
            content: "";
            position: absolute;
            z-index: 9999;
          }
          img{
            width: 120px;
          }
        }
      }
    }
  }
  &.jobs{
    background: #fff;
    text-align: center;
    color: #333;
    padding-top: 50px;
  }
  &.resume {
    /* width: 100%; */
    position: relative;
    margin-top: 50px;
    text-align: center;
    color: #333;
    img{
      width: 800px;
      padding: 100px 0 50px;
    }
    &::before{
      width: 140%;height: 780px;
    }
    h3{
      margin-top: 50px;
    }
  }
  &.many{
    text-align: center;
    color: #333;
    padding: 50px 0;
    img{
      width: 1000px;
      margin-top: 80px;
    }
  }
  &.demo{
    h3{
      color: #333;
    }
    .lists{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 50px;
      .item{
        margin-bottom: 40px;
      }
      img{
        width:475px;
        height: 233px;
        border-radius: 28px;
      }
    }
  }
  &.footer{
    background: #34363E;
    padding: 32px 0;
    text-align: center;
  }
}
.popup{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  .p-body{
    position: absolute;
    width: 600px;
    height: 500px;
    background: #fff;
    color: #333;
    box-sizing: border-box;
    padding: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .p-title{
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    span{
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 30px;
      font-weight: 100;
      cursor: pointer;
      padding: 0 5px;
    }
  }
  p{
    line-height: 2;
    &.q{
      font-weight: 500;
      margin: 10px 0;
    }
    &.a{
      color: #666;

      font-size: 14px;
    }
  }
}
.items{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 50px;
  .item{
    width: 900px;
    text-align: center;
    display: flex;
    height: 300px;
    overflow: hidden;
    margin-bottom: 60px;
    img{
      width: 100%;
      height: 300px;
    }
    &:last-child{
      // width: 569px;
    }
  }
}
.mutil{
  // margin-top: 80px;
  padding: 40px 0;
  // background: linear-gradient(90deg, rgba(29, 97, 232,0.3), rgba(211, 230, 252,0.3));
  color: #333;
  background: url('../assets/mutilbg.png') no-repeat;
  background-size: 100% auto;
}
.hezuo{
  color: #333;
  margin-top: 80px;
  margin-bottom: 80px;
  span{
    color: #CE5653;
  }
  .lists{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 40px;
    div{
      width: 240px;
      height: 240px;
      background: #fcfcfc;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #f4f4f4;
      border-bottom: 1px solid #f4f4f4;
      box-sizing: border-box;
      &:hover{
        background: rgba(55, 111, 246, 0.3);
      }
    }
    img{
      width: 120px;
      height: 120px;
      border-radius: 120px;
    }
  }
}
.color{
  color:#CE5653 ;
}
@media screen and (max-width: 768px) {
  .menu{
    .content{
      padding: 15px 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .right-menu{
      display: none;
    }
  }
  .index-content{
    .title{
      font-size: 30px;
      // flex-direction: column;
      align-items: flex-end;
      div{      
        span:first-child{
          color: #CE5653;
          font-family: 'Truth';
          font-size: 30px;
        }
      }
      .subfix{
        // margin-left: 0;
        font-size: 17px;
        // margin-top: 10px;
      }
    }
  }
  .sub-title{
    .pc,.phone{
      display: none;
    }
    span::before{
      top:8px !important;
      margin-top: 0 !important;
    }
  }
  .h5{
      display: inline-block !important;
      margin-bottom: 5px;
    }
  .buttons{
    display: none;
  }
  .main.index{
    flex-direction: column;
    width: 100%;
    margin-top: 100px;
    box-sizing: border-box;
    padding: 0 20px;
    justify-content: center;
    .video {
      width: 100%;
      height: auto;
      margin-top: 40px;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .main-wrapper.index{
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 730px;
    .app{
      display: none;
    }
    .m-app{
      display: flex;
      align-items: center;
      text-align: center;
      flex-direction: column;
      color: #333;
      margin-top: 20px;
      .ddd{
        display: flex;
        align-items: center;
      text-align: center;
      flex-direction: column;
      }
      .qrcode{
        margin-top: 10px;
        img{
          width: 150px;
        }
      }
    }
  }
  .main-wrapper.jobs{
    display: none;
  }
  .main{
    width: 100%;
  }
  .hezuo{
    margin-top: 40px;
    margin-bottom: 40px;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .hezuo .lists{
    width:100%;
    justify-content: center;
    div{
      width: 50%;
    }
  }
  .main-wrapper.demo {
    .lists{
      box-sizing: border-box;
      padding: 0 20px;
      .item{
        margin-bottom: 20px;
      }
      img{
        width:100%;
        height: auto;
      }
    }
  }
  .main-wrapper.footer{
    font-size: 14px;
  }
  .mutil{
    background-size: auto 100%;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  h3{
    font-size: 28px;
  }
  p,span{
    text-align: left;
  }
}
</style>
